module.exports = __webpack_public_path__ + "img/bank-card-black.7cc89719.png";